import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/data/company";

/**
 * schema.org/Service JSON-LD for a service leaf page.
 * Deliberately conservative — no offers, no aggregateRating, no fake pricing.
 * Provider references the site-wide LocalBusiness @id to avoid duplication.
 */
const ServiceSchema = ({ slug, name, description, categoryName }) => {
  const url = `https://www.lutrom.co.uk/services/${slug}`;

  const data = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${url}#service`,
    name,
    description,
    url,
    ...(categoryName ? { serviceType: categoryName, category: categoryName } : {}),
    provider: { "@id": "https://www.lutrom.co.uk/#business" },
    areaServed: [
      { "@type": "AdministrativeArea", name: "North West England" },
      { "@type": "AdministrativeArea", name: "Cheshire" },
      { "@type": "AdministrativeArea", name: "Greater Manchester" },
      { "@type": "AdministrativeArea", name: "Merseyside" },
      { "@type": "AdministrativeArea", name: "Lancashire" },
    ],
    brand: { "@type": "Brand", name: COMPANY.name },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default ServiceSchema;
